// extracted by mini-css-extract-plugin
export var infoPanel = "styles-module--infoPanel--5b980";
export var infoPanelOuter = "styles-module--infoPanelOuter--e9237";
export var items = "styles-module--items--b6ccb";